import React, { useEffect } from 'react';

import qs from 'query-string';
import { Base64 } from 'js-base64';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  storeRedirect,
  facebookSignIn,
  storeSubdomain,
} from '../../store/modules/auth/actions';

import { IAuthState } from '../../store/modules/auth/types';

import { IState } from '../../store';

import {
  Button,
  Wrapper,
  Container,
  ContainerError,
  ContainerButton,
} from './styles';

const FacebookLoginPage: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { token, redirect, subdomain, error } = useSelector<IState, IAuthState>(
    state => state.auth,
  );

  useEffect(() => {
    if (redirect && subdomain && token) {
      switch (process.env.REACT_APP_ENV) {
        case 'production': {
          window.location.replace(
            `https://${subdomain}.bsfood.com.br/loading?token=${token}&redirect=${redirect}`,
          );
          break;
        }

        case 'staging': {
          window.location.replace(
            `https://menustaging.bsfood.com.br/loading?token=${token}&redirect=${redirect}`,
          );
          break;
        }

        default: {
          window.location.replace(
            `http://localhost:3000/loading?token=${token}&redirect=${redirect}`,
          );
        }
      }
    }
  }, [redirect, subdomain, token]);

  useEffect(() => {
    const { access_token, state } = qs.parse(history.location.hash);

    if (typeof state === 'string' && typeof access_token === 'string') {
      const stateObject = JSON.parse(Base64.atob(state));

      dispatch(storeRedirect(stateObject.redirect));
      dispatch(storeSubdomain(stateObject.subdomain));
      dispatch(
        facebookSignIn({
          accessToken: access_token,
          token: stateObject.token,
        }),
      );
    } else {
      history.push('/error');
    }
  }, [history, dispatch]);

  useEffect(() => {
    if (error === 'reCAPTCHA inválido') {
      history.push(`/?subdomain=${subdomain}&redirect=${redirect}`);
    }
  });
  return (
    <Wrapper>
      {error ? (
        <ContainerError>
          <h1>Não conseguimos fazer seu login 😞</h1>
          <p>{`Motivo do erro:  ${error}`}</p>
          <ContainerButton>
            <Button
              type="button"
              outline
              onClick={() =>
                window.location.replace(`https://${subdomain}.bsfood.com.br`)
              }
            >
              Seguir sem login
            </Button>
            <Button
              type="button"
              onClick={() =>
                history.push(`/?subdomain=${subdomain}&redirect=${redirect}`)
              }
            >
              Tentar outro método de login
            </Button>
          </ContainerButton>
        </ContainerError>
      ) : (
        <Container />
      )}
    </Wrapper>
  );
};

export default FacebookLoginPage;
